// Altitude

import {SimulatorEntryInterface, SimulatorPagesInterface} from '../../interfaces/simulator-entry';

export class EntryPageAL {
  static initial(simulatorEntry: SimulatorEntryInterface) {
    simulatorEntry.page = SimulatorPagesInterface.AL;
    simulatorEntry.display.data = 'AL';
  }

  static clickButtonSettings(simulatorEntry: SimulatorEntryInterface): boolean {
    return false;
  }
}
